export default __webpack_public_path__ + "static/media/dipu.32f8baa2.png";